import { render, staticRenderFns } from "./product4.vue?vue&type=template&id=29048b53&scoped=true"
import script from "./product4.vue?vue&type=script&lang=js"
export * from "./product4.vue?vue&type=script&lang=js"
import style0 from "./product4.vue?vue&type=style&index=0&id=29048b53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29048b53",
  null
  
)

export default component.exports